import {
  FiHeart,
  FiHome,
  FiShoppingBag,
  FiActivity,
  FiBookOpen,
} from 'react-icons/fi';

export const industries = [
  {
    slug: 'healthcare',
    icon: FiHeart,
    title: 'Healthcare',
    short: 'Clinics, hospitals, diagnostic labs and telehealth.',
    description:
      'Booking systems, patient portals, EMR integrations and HIPAA-aware web apps. We have shipped products for clinics, dental practices and diagnostic labs.',
    pain: 'Paper-heavy workflows, missed follow-ups, no patient self-service.',
    outcomes: [
      'Online appointment booking 24/7',
      'Automated reminders &amp; follow-ups',
      'Doctor &amp; patient portals',
      'HIPAA / DPDP-aware data handling',
    ],
    accent: '#06b6d4',
    cover: '/img/industry/healthcare.jpg',
  },
  {
    slug: 'real-estate',
    icon: FiHome,
    title: 'Real Estate',
    short: 'Builders, brokers, property platforms.',
    description:
      'Property listing portals, virtual tours, lead capture funnels and CRM integration — built for the way Indian buyers actually search.',
    pain: 'Leads scattered across WhatsApp, no listing management, slow site.',
    outcomes: [
      'Searchable listing portals',
      'Virtual tours &amp; gallery sites',
      'WhatsApp + CRM lead capture',
      'Geo-targeted Google Ads',
    ],
    accent: '#6366f1',
    cover: '/img/industry/real-estate.jpg',
  },
  {
    slug: 'ecommerce',
    icon: FiShoppingBag,
    title: 'Ecommerce',
    short: 'D2C brands, marketplaces, B2B catalog ordering.',
    description:
      'Shopify-grade storefronts, custom checkouts, marketplace platforms — and the analytics + ads engine to grow them month over month.',
    pain: 'Slow site, abandoned carts, ROAS that does not compound.',
    outcomes: [
      'High-converting storefronts',
      'Custom checkout &amp; payments',
      'Inventory &amp; ERP integration',
      'Performance ads &amp; retargeting',
    ],
    accent: '#f59e0b',
    cover: '/img/industry/ecommerce.jpg',
  },
  {
    slug: 'natural-nutrition',
    icon: FiActivity,
    title: 'Natural &amp; Nutrition',
    short: 'Wellness brands, nutritionists, supplements, organic D2C.',
    description:
      'Brand-first storefronts, subscription billing, content engines and influencer-friendly funnels for natural health and nutrition businesses.',
    pain: 'Generic templates, no story, low repeat purchase rate.',
    outcomes: [
      'Brand storytelling sites',
      'Subscription &amp; refill flows',
      'Content &amp; SEO engine',
      'Influencer attribution',
    ],
    accent: '#10b981',
    cover: '/img/industry/nutrition.jpg',
  },
  {
    slug: 'education',
    icon: FiBookOpen,
    title: 'Education',
    short: 'Schools, coaching centres, EdTech platforms.',
    description:
      'School websites, coaching admission portals, LMS platforms, parent portals and online assessment tools — built for trust and accessibility.',
    pain: 'Outdated school site, manual admissions, no online classes.',
    outcomes: [
      'Modern school &amp; college websites',
      'Admission &amp; enquiry portals',
      'LMS &amp; live class platforms',
      'Parent &amp; student dashboards',
    ],
    accent: '#8b5cf6',
    cover: '/img/industry/education.jpg',
  },
];

export const findIndustry = (slug) => industries.find((i) => i.slug === slug);
